import { render } from "./DrawingBoard.vue?vue&type=template&id=49209448&scoped=true"
import script from "./DrawingBoard.vue?vue&type=script&lang=js"
export * from "./DrawingBoard.vue?vue&type=script&lang=js"

import "./DrawingBoard.vue?vue&type=style&index=0&id=49209448&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49209448"]])

export default __exports__